import type { FilterOptions } from "@/shared/types/types";

export function buildQueryString(options: FilterOptions = {}): string {
    const params = new URLSearchParams();

    if (options.search) params.append('search', options.search);
    if (options.status) params.append('status', options.status);
    if (options.severity) params.append('severity', options.severity);
    if (options.alertType) params.append('alertType', options.alertType);
    if (options.deviceId) params.append('deviceId', options.deviceId);
    if (options.tipoUsuario) params.append('tipoUsuario', options.tipoUsuario);
    if (options.linkStatus) params.append('linkStatus', options.linkStatus);
    if (options.assignmentStatus) params.append('assignmentStatus', options.assignmentStatus);
    if (options.groupId) params.append('groupId', options.groupId);
    if (options.clientId) params.append('clientId', options.clientId);
    if (options.accountId) params.append('accountId', options.accountId);
    if (options.operatingSystem) params.append('operatingSystem', options.operatingSystem);
    if (options.page) params.append('page', String(options.page));
    if (options.limit) params.append('pageSize', String(options.limit));
    if (options.sortBy) params.append('sortBy', options.sortBy);
    if (options.sortOrder) params.append('sortOrder', options.sortOrder);

    const queryString = params.toString();
    return queryString ? `?${queryString}` : '';
  }
